export default __webpack_public_path__ + "static/media/icon-03.20a21e1a.svg";